import React from "react";
import LatexTable from "./LatexTable/LatexTable";
import SolidosTable from "./SolidosTable/SolidosTable";
import SKIMTable from "./SKIMTable/SKIMTable";


export default function ComparativoCostoMP() {
    return (
        <div className="report__container">
            <SolidosTable />
            <LatexTable />
            <SKIMTable />
        </div>
    );
}
